// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__205Ld","containerItemsCenter":"Skeleton_containerItemsCenter__LeDZq"};